webpackJsonp([63265143360458],{

/***/ 732:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyImage = __webpack_require__(24);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _reactHelmet = __webpack_require__(7);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _config = __webpack_require__(8);
	
	var _Fleet = __webpack_require__(20);
	
	var _Fleet2 = _interopRequireDefault(_Fleet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FleetEn = function FleetEn(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'page fleet' },
	    _react2.default.createElement(_reactHelmet2.default, {
	      title: 'Best Vehicles for Rental at Budget Nicaragua',
	      meta: [{
	        name: 'description',
	        content: 'Frequently Asked Questions about car rentals. Contact Us: SJO: +506 2436-2070 / LIR: +506 2436-2071.'
	      }],
	      link: [{
	        rel: 'alternate',
	        hreflang: 'en',
	        href: './es/fleet/fleet'
	      }]
	    }),
	    _react2.default.createElement(
	      'div',
	      { className: 'top-bg' },
	      _react2.default.createElement(_gatsbyImage2.default, {
	        sizes: props.data.imageSharp.sizes,
	        style: { width: '100%', position: 'absolute', zIndex: '-1' }
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'excerpt' },
	      _react2.default.createElement(
	        'h1',
	        null,
	        'Meet Out Fleet'
	      ),
	      _react2.default.createElement(
	        'h3',
	        null,
	        'From luxury 4x4 to economy vehicles, we have the car you need.'
	      )
	    ),
	    _react2.default.createElement(_Fleet2.default, {
	      lang: props.pathContext.langKey,
	      types: props.data.dataJson.fleetTypes,
	      features: props.data.dataJson.fleetFeatures,
	      displayFilter: true
	    })
	  );
	};
	
	//Components
	var query = exports.query = '** extracted graphql fragment **';
	exports.default = FleetEn;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-fleet-index-en-js-7a38f14495376ac16196.js